<template>
  <div class="mt-8 mb-1 lg1024:mt-12 lg1024:mb-3">
    <span class="text-lighter">{{ $t('unauth_have_acc') }}&nbsp;</span>
    <span class="font-medium text-accentColor cursor-pointer" data-qa="step0-login-trigger" @click="openAuth">
      {{ $t('unauth_login') }}
    </span>
  </div>
</template>

<script setup>
const emit = defineEmits(['open-auth'])
const openAuth = () => emit('open-auth')
</script>
